import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface EstatusAsamblea {
  eas_codigo: string;
  eas_nombre: string;
}

export const obtenerEstatusAsamblea = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusAsamblea[]>>(
    "estatus_asamblea/ObtenerTodos",
    HttpMethod.POST,
    {}
  );

  return envelope;
};
